import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const TopicBubble = ({ id, title, icon, subTopics }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        onClick={() => navigate(`/topic/${id}`)}
        className={`
          cursor-pointer
          transition-all duration-300
          transform-gpu
          ${isHovered ? 'scale-105' : 'scale-100'}
          bg-gradient-to-br from-blue-500 to-blue-600
          text-white
          rounded-full
          aspect-square
          flex flex-col items-center justify-center
          p-8
          shadow-lg
          hover:shadow-xl
        `}
      >
        <div className="text-4xl mb-4">{icon}</div>
        <h2 className="text-xl font-bold text-center">{title}</h2>
        <ChevronDown 
          className={`
            mt-4 
            transition-transform duration-300
            ${isHovered ? 'translate-y-1' : ''}
          `}
        />
      </div>

      {/* SubTopics Dropdown */}
      <div
        className={`
          absolute
          top-full
          left-0
          right-0
          mt-2
          bg-white
          rounded-lg
          shadow-xl
          p-4
          transition-all duration-300
          transform-gpu
          origin-top
          ${isHovered ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'}
          z-10
        `}
      >
        {subTopics.map((subTopic, index) => (
          <div
            key={index}
            className="py-2 px-4 hover:bg-blue-50 rounded cursor-pointer transition-colors duration-200"
          >
            <h3 className="font-semibold">{subTopic.title}</h3>
            <p className="text-sm text-gray-600">{subTopic.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopicBubble;